import React, {useState} from 'react';
import CheckboxParameter from 'components/effects/CheckboxParameter.js';
import Colors from 'components/Colors.js';
import SampleSearch from './SampleSearch.js';
import MixModeDropdown from './MixModeDropdown.js';
const colors = new Colors();

const names = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l'];

export default ({instrument, sampler, setSelectedSampler, toggleShowPiano, showPianoRoll}) => {
    const [showSampleSearch, setShowSampleSearch] = useState(false);
    let noteForSampler = Object.keys(instrument.samplers).find(
        note => instrument.samplers[note].indexOf(sampler) > -1);
    let samplers = instrument.samplers[noteForSampler] || [];

    let sampleSearch = '';
    if (showSampleSearch) {
        sampleSearch = (
            <SampleSearch
              setSelectedSampler={setSelectedSampler}
              hide={() => setShowSampleSearch(false)}
              instrument={instrument}/>);
    }
    
    return (
        <div className="advanced-controls">
          <div className="samples-container">
            {samplers.map(
                (s, i) =>
                    <div
                      className={sampler === s ? "selected sampled-sound" : "sampled-sound"}
                      onClick={() => setSelectedSampler(s)}
                      style={{
                          backgroundColor: colors.getColorForHash(s.sample.getId())}}>
                      {names[i]}
                    </div>)}
            <div
              onClick={() => setShowSampleSearch(true)}
              className="add-sample-button">
              +
            </div>
            <img
              onClick={toggleShowPiano}
              className={showPianoRoll ? "piano-icon on" : "piano-icon"} src="/piano-icon.png"/>
          </div>
          {sampleSearch}
          <div className="drop-here">
            Drop samples here
          </div>
          <div className="sampler-dropdowns">
            <div>
              <CheckboxParameter name="Mono" parameter={instrument.monophonicParameter}/>
              <CheckboxParameter name="Loop" parameter={instrument.loopParameter}/>
            </div>
            <MixModeDropdown instrument={instrument}/>
          </div>
        </div>
    );
};
